import { CreateAuthentication } from "@musicaudienceexchange/firebase-auth-ui";

export const { useUser, UserContext, UserProvider } = CreateAuthentication({
  loadClaims: (data) => ({
    isAdmin: typeof data.admin === "boolean" && data.admin === true,
  }),
});
